import { loadStripe } from '@stripe/stripe-js'
import { supabase } from '../lib/supabase'

const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY

// Allow development without Stripe key

export const stripePromise = stripePublishableKey ? loadStripe(stripePublishableKey) : null

export const createCheckoutSession = async (priceId: string, couponCode?: string) => {
  if (!stripePublishableKey) {
    throw new Error('Stripe is not configured. Please add your Stripe publishable key to enable billing functionality.')
  }

  const body: { priceId: string; couponCode?: string } = { priceId }
  if (couponCode) body.couponCode = couponCode.trim().toUpperCase()

  const { data, error } = await supabase.functions.invoke('create-checkout-session', {
    body
  })

  if (error) throw error
  return data
}

export const createPortalSession = async () => {
  if (!stripePublishableKey) {
    throw new Error('Stripe is not configured. Please add your Stripe publishable key to enable billing functionality.')
  }

  const { data, error } = await supabase.functions.invoke('create-portal-session')

  if (error) throw error
  return data
}

export const redirectToCheckout = async (priceId: string, couponCode?: string) => {
  try {
    if (!stripePublishableKey) {
      throw new Error('Stripe is not configured. Please add your Stripe publishable key to enable billing functionality.')
    }

    // Se nenhum cupom foi passado explicitamente, lê de ?coupon= na URL atual.
    let resolvedCoupon = couponCode
    if (!resolvedCoupon && typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search)
      const fromUrl = params.get('coupon') || params.get('promo')
      if (fromUrl) resolvedCoupon = fromUrl
    }

    const { sessionId } = await createCheckoutSession(priceId, resolvedCoupon)
    const stripe = await stripePromise

    if (!stripe) {
      throw new Error('Stripe not loaded')
    }

    const { error } = await stripe.redirectToCheckout({ sessionId })

    if (error) {
      throw error
    }
  } catch (error) {
    throw error
  }
}

export const openBillingPortal = async () => {
  try {
    if (!stripePublishableKey) {
      throw new Error('Stripe is not configured. Please add your Stripe publishable key to enable billing functionality.')
    }

    const { url } = await createPortalSession()
    window.location.href = url
  } catch (error) {
    throw error
  }
}

export const isStripeConfigured = () => {
  return !!stripePublishableKey
}

export const isTestMode = () => {
  return stripePublishableKey?.startsWith('pk_test_') || false
}

